import { GET, POST, PUT } from '../request'

export const getProfesorList = () => GET('/api/core/personal/profesor/list')

export const createProfesor = ({ nombre, email, rol, asignaturas }) =>
  POST('/api/core/personal/profesor', {
    nombre,
    email,
    rol,
    'asignaturas[]': asignaturas
  })

export const editProfesor = ({
  id,
  acceso,
  nombre,
  rol,
  email,
  asignaturas,
  visibleClassfy
}) =>
  PUT('/api/core/personal/profesor', {
    id,
    acceso,
    nombre,
    rol,
    email,
    'asignaturas[]': asignaturas,
    visible_classfy: visibleClassfy
  })
